import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import { Warning, Restore } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  warningIcon: {
    color: theme.palette.warning.main,
  },
  content: {
    paddingTop: theme.spacing(2),
  },
  warningBox: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  infoList: {
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  actions: {
    padding: theme.spacing(2),
  },
}));

const RollbackConfirmationModal = ({ open, onClose, onConfirm, version }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box className={classes.dialogTitle}>
          <Warning className={classes.warningIcon} />
          <Typography variant="h6">
            Confirmar Restauración de Versión
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography variant="body1" gutterBottom>
          ¿Estás seguro de que deseas restaurar esta versión anterior?
        </Typography>
        
        <Alert severity="warning" className={classes.warningBox}>
          <Typography variant="body2">
            Esta acción publicará inmediatamente la versión seleccionada como la versión actual de la landing page.
          </Typography>
        </Alert>

        <Typography variant="body2" color="textSecondary">
          Información de la versión:
        </Typography>
        <Box className={classes.infoList}>
          <Typography variant="body2">
            • La versión anterior se publicará inmediatamente
          </Typography>
          <Typography variant="body2">
            • Los visitantes verán el contenido restaurado de inmediato
          </Typography>
          <Typography variant="body2">
            • Se creará un nuevo snapshot de la versión actual antes de restaurar
          </Typography>
          <Typography variant="body2">
            • Podrás volver a la versión actual más tarde si es necesario
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button onClick={onClose} color="default">
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          color="secondary"
          variant="contained"
          startIcon={<Restore />}
        >
          Confirmar Restauración
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RollbackConfirmationModal;
